export default {"src":"/_next/static/media/AED.f172058c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};